import { render, staticRenderFns } from "./AdmissionElement.vue?vue&type=template&id=e4771d5a"
import script from "./AdmissionElement.vue?vue&type=script&lang=js"
export * from "./AdmissionElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports